// frontend/src/components/UsePageTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Assuming you're using React Router

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // This effect runs every time the location (URL) changes
    console.log(`Page visited: ${location.pathname}${location.search}`);
    // Here you would integrate with your actual analytics service, e.g.:
    // analytics.trackPageView(location.pathname + location.search);

    // You could also add other common page-specific effects here, e.g.,
    window.scrollTo(0, 0); // Scroll to top on every page view
  }, [location]); // Re-run effect when the location object changes
};

export default usePageTracking;